import React, { ReactElement } from 'react';
import M, { datejs } from '@block/utils';
import _ from 'lodash';
import { notification, Button, Steps, Modal, Icon, Checkbox } from '@ss/mtd-react';
import { RouteComponentProps } from 'react-router';
import { doAction, getServiceType } from '../../utils';
import logo from '../../../imgs/logo.png';
import Url from './url';
import BasicInfo from '../basicInfo';
import BankInfo from '../bankInfo';
import HealthInfo from '../healthInfo';
import PersonInfo from '../personInfo';
import PersonBackground from '../personBackground';
import EducationInfo from '../educationInfo';
import WorkInfo from '../workInfo';
import TaxInfo from '../taxInfo';
import Declaration from '../declaration';
import Feedback from './feedback';
import Preview from '../preview';
import ConformModal from './elements/ConformModal';
import { STEP_ENUM, BACKGROUND_STEP_ENUM, btnsMap } from './const';
import './index.scss';

const { Step } = Steps;

const isMrnAble =
  window.location.href.includes('fromMRN') || (window.NX?.getUA().isNEIXIN && window.NX.compareVersion('5.16.0') <= 0);

// 信息填写以及展示页面
// 此页面根据状态判断的较多 状态枚举值  1 未提交  3 待初审 5 待复审 7 复审通过 9 已退回 11 已入职 13 拒绝入职

type Props = RouteComponentProps<{}, {}>;

interface State {
  status: number | string;
  saveDate: any;
  tabLists: any;
  activeTab: any;
  operateBtns: any[]; // 操作按钮
  activeEnum: any; // 步骤条激活集合
  editable: boolean; // 是否可编辑 默认可编辑
  check: boolean; // 个人信息承诺书的展示标识
  visible: boolean;
  isFirstWork?: boolean;
  needComputerTypeValidate?: boolean; // 是否需要校验个人信息中的电脑类型
}
class List extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.basicInfo = React.createRef(); // 基本信息
    this.personalInfo = React.createRef(); // 个人信息
    this.bankInfo = React.createRef(); // 银行信息
    this.educationsInfo = React.createRef(); // 教育经历
    this.worksInfo = React.createRef(); // 工作经历
    this.commitment = React.createRef(); // 个人纳税
    this.declaration = React.createRef(); // 利益申报
    this.healthInfo = React.createRef(); // 健康信息
    this.state = {
      status: '',
      saveDate: null,
      tabLists: {},
      activeTab: '',
      operateBtns: [], // 操作按钮
      activeEnum: {}, // 步骤条激活集合
      editable: true, // 是否可编辑 默认可编辑
      check: false, // 个人信息承诺书的展示标识
      visible: false,
      needComputerTypeValidate: false,
    };
  }

  basicInfo: React.RefObject<any>;

  personalInfo: React.RefObject<any>;

  bankInfo: React.RefObject<any>;

  educationsInfo: React.RefObject<any>;

  worksInfo: React.RefObject<any>;

  commitment: React.RefObject<any>;

  declaration: React.RefObject<any>;

  healthInfo: React.RefObject<any>;

  async componentDidMount() {
    await getServiceType();
    const tenantUid = window.location.hash.split('/')[2];
    if (!window.hasSign && window.signType !== 0) {
      window.location.href = `/#/candidate/${tenantUid}/sign`;
      return;
    }
    const infoDetail = (await this.getInfoDetail()) || {};
    const { status } = infoDetail;
    const canOperate = status === 1 || status === 9;
    this.setState(
      {
        editable: canOperate,
      },
      () => {
        this.getTabList(status);
      },
    );

    const { location } = this.props;
    if (location.search && isMrnAble) {
      document.getElementById('app').style.height = 'auto';
    }
  }

  handleLogout = async () => {
    await doAction(Url.logout, {}, null);
    const { hash } = window.location;
    const arr = hash.split('/');
    const tenantUid = arr[2];
    window.location.hash = `#/candidate/${tenantUid}/login`;
  };

  /**
   * 手动保存草稿
   */
  handleDraftSave = async () => {
    const { activeTab = {} as any } = this.state;
    const { code } = activeTab;
    const ref = this[code].current;

    let url = '';
    switch (code) {
      case 'educationsInfo':
        // 教育经历需要v2的接口
        url = `/api/candidate/draft/${code}/v2/save`;
        break;
      default:
        url = `/api/candidate/draft/${code}/save`;
        break;
    }
    // 获取最终数据
    const finalData = await ref?.handleFetchFinalData?.();

    // return;
    // 发送保存请求
    const res = await doAction(url, finalData, null); // 请求草稿接口
    if (res) {
      ref.dataChanged = false;
      // 显示保存成功通知
      notification.info({
        title: '保存成功',
      });
      const date = new Date().getTime();
      // 更新保存时间
      this.setState({
        saveDate: `手动保存于 ${datejs(date).format('YYYY-MM-DD HH:mm:ss')}`,
      });
    }
  };

  /**
   * 处理标签页适配
   * @param res 标签页数据
   * @returns 处理后的标签页数据和最后一个必填标签页
   */
  handleAdapterTab = (res) => {
    const obj: any = {};
    let index = -1;
    let lastRequiredTab;
    const tabLists = _.map(res, (item, i) => {
      if (!item.checked) {
        if (index === -1) {
          index = i;
        } else {
          item.disabled = true;
        }
      }
      if (!lastRequiredTab && !item.required && i > 0) {
        lastRequiredTab = res[i - 1];
      }
      return item;
    });
    obj.tabLists = tabLists;
    obj.lastRequiredTab = lastRequiredTab;
    return obj;
  };

  /**
   * 处理标签页切换
   * @param ref 当前标签页引用
   * @param newTab 新标签页
   */
  handleTabChange = async (ref, newTab) => {
    // 先保存，保存中存在校验
    // 如果是提交，是直接 handleFetchFinalData 获取数据来请求接口
    // 如果是保存，是 handleSave 内部先校验之后再 handleFetchFinalData 获取数据来请求接口
    const canSave = await ref?.handleSave?.();
    if (canSave !== false) {
      const { status } = this.state;
      // 获取标签页列表
      const res = await doAction(Url.tabLists, null);
      const { tabLists, lastRequiredTab } = this.handleAdapterTab(res);
      // 更新状态
      this.setState({ tabLists, activeTab: newTab });
      this.getBtns(tabLists, status, newTab, lastRequiredTab);
    }
  };

  /**
   * 处理上一步标签页切换
   * @param ref 当前标签页引用
   * @param newTab 新标签页
   * @param code 当前标签页代码
   */
  handlePreTabChange = async (ref, newTab, code) => {
    if (!ref) return;
    const { status } = this.state;
    const url = `/api/candidate/draft/${code}/save`;
    // 获取最终数据
    const finalData = await ref?.handleFetchFinalData?.();
    // 保存当前标签页数据
    await doAction(url, finalData, null);
    // 获取标签页列表
    const res = await doAction(Url.tabLists, null);
    const { tabLists, lastRequiredTab } = this.handleAdapterTab(res);
    // 更新状态
    this.setState({ tabLists, activeTab: newTab });
    this.getBtns(tabLists, status, newTab, lastRequiredTab);
  };

  /**
   * 检查是否选择了正确的电脑类型
   * @returns 是否选择了正确的电脑类型
   */
  getRightComputerType = async () => {
    let isRightComputerType = false;
    try {
      /** 查询办公电脑是否符合当前JF/JG */
      isRightComputerType = await doAction(Url.getComputerType, null);
    } catch (error) {
      isRightComputerType = false;
    }
    return isRightComputerType;
  };

  // 操作按钮:上一步/下一步/跳过/预览/提交
  handleOperate = async (code: string) => {
    const { tabLists = [], activeTab = {} as any, status } = this.state;
    const { code: activeCode } = activeTab;
    const ref = this[activeCode].current;
    const index = _.findIndex(tabLists, { code: activeCode });
    const data = this.handleAdapterTab(tabLists);
    let canSave = null;
    if (code === 'edit') {
      this.setState({ editable: true }, () => {
        this.getTabList(status);
      });
    } else {
      if (code === 'submit') {
        // 入职候选人条件下，新增单独判断
        if (window.checkTypeValue === 'entry') {
          // 如果不是 personalInfo 页面，需要跳转，判断电脑后，可能会清空电脑表单项并校验和定位
          if (activeCode !== 'personalInfo') {
            // 获取标识
            const isRightComputerType = await this.getRightComputerType();

            // 如果不是正确电脑类型
            if (!isRightComputerType) {
              // 在非personalInfo 页面，需要跳转到 personalInfo 页面让其修改
              const personalInfo = tabLists?.find((tab) => tab?.code === 'personalInfo');

              // 个人信息的保存功能中，处理 电脑类型 表单项 校验飘红
              await this.handlePersonInfoComputerTypeCheck(personalInfo);
              // handlePersonInfoComputerTypeCheck内部需要处理极端场景：其他页面的预览页进行提交

              // 不执行后续提交submit
              return;
            }
          } else {
            // 如果是 personalInfo 页面，有3种情况
            // 1、原本在 personalInfo页，直接点提交，需要先保存，再校验电脑，发现不对再清空，再提示
            // 2、其他页跳转回来定位到电脑，已经清空了电脑，这个时候点提交
            // 3、personalInfo 的预览页，点击提交，这种情况理论上不存在，因为在当前页先点击预览的时候，会校验
            // 能从personalInfo进入预览说明已经主动修正过过电脑类型了
            // 前两种种情况都会在保存后、提交前进行电脑校验，所以放在handleSave里
            await ref?.handleSave?.();
          }
        }

        if (ref) {
          canSave = await ref?.handleSave?.();
        } else {
          canSave = true;
        }
      }
      switch (code) {
        case 'submit':
          if (canSave !== false) {
            Modal.info({
              title: '重要提示',
              message:
                '入职信息您已填写完成，请再次确认您所填写的信息完整、真实、准确，并承诺已充分了解提供虚假或隐瞒信息为严重违反公司制度的行为，公司将有权解除劳动合同且无需承担经济补偿的后果。',
              okText: '确认',
              okBtnProps: { type: 'primary' },
              cancelText: '取消',
              onOk: async () => {
                const res = await doAction(Url.submit, {}, null);
                notification.success({
                  title: '成功',
                  message: '保存成功',
                });
                if (res && window.checkTypeValue === 'entry') {
                  window.location.href = '/#/candidate/1/home';
                }
                if (res && window.checkTypeValue === 'background') {
                  window.location.href = '/#/candidate/1/success';
                }
                const pathname = (window.location.hash.slice(1) && window.location.hash.slice(1)) || '/';
                const misId = M.getCookie('_lxsdk_cuid'); // 灵犀PC端的用户设备标识，用来区分UV的
                const time = new Date().getTime(); // 获取页面时间戳
                const valLab = { custom: { pathname, misId, time } };
                window.LXAnalytics('moduleClick', 'b_ead_9v0dliw1_mc', valLab, {
                  cid: 'c_ead_29djhaw2',
                });
              },
              onCancel: () => console.log('Click Cancel'),
            });
          }
          break;
        case 'prev':
          this.handlePreTabChange(ref, tabLists[index - 1], activeCode);
          break;
        case 'next':
          this.handleTabChange(ref, tabLists[index + 1]);
          break;
        case 'preview':
          canSave = await ref?.handleSave?.();

          if (
            // 入职候选人系统
            window.checkTypeValue === 'entry' &&
            // 个人信息页
            activeCode === 'personalInfo' &&
            // personalInfo 当前页面不满足校验规则的时候
            canSave === false
            // handleSave内部会判断是否满足电脑类型
          ) {
            // 不能进行预览，handleRejectedComputerType内部会进行提示
            break;
          }

          // 其他场景正常预览即可
          this.setState({ editable: false }, () => {
            if (canSave !== false) {
              this.getBtns(tabLists, status, activeTab, data.lastRequiredTab);
            }
          });
          break;
        case 'save':
          // 保存按钮
          this.handleDraftSave();
          break;
        default:
          break;
      }
    }
  };

  // 电脑类型在驳回后，需要自动校验
  handlePersonInfoComputerTypeCheck = async (item) => {
    if (!item) return;

    // 处理当前表单页的保存功能
    const { activeTab } = this.state;
    const ref = this[activeTab.code].current;
    const canSave = await ref?.handleSave?.();
    // 如果当前页可以保存，就开启电脑校验并跳转到个人信息页
    if (canSave !== false) {
      const { status } = this.state;
      const res = await doAction(Url.tabLists, null);
      const { tabLists, lastRequiredTab } = this.handleAdapterTab(res);
      this.setState(
        {
          tabLists,
          activeTab: item,
          // 预览态回到编辑态
          editable: true,
          // 开启个人信息电脑类型校验，作为props传入子组件
          needComputerTypeValidate: true,
        },
        () => {
          // 跳转目标页
          this.getBtns(tabLists, status, item, lastRequiredTab);
        },
      );
    }
    // 如果不可以保存，handleSave 内部会自动飘红校验目标项
  };

  handleClick = (e, item) => {
    const { activeTab } = this.state;
    const ref = this[activeTab.code].current;
    this.handleTabChange(ref, item);
  };

  // 获取当前用户填写信息的状态
  getInfoDetail = async () => {
    const infoDetail = (await doAction(Url.homeDetail, {}, null)) || {};
    this.setState({
      status: infoDetail.status,
    });
    return infoDetail;
  };

  // 获取信息录入模块列表
  getTabList = async (status) => {
    const res = (await doAction(Url.tabLists, {}, null)) || [];
    let activeTab;
    let index = -1;
    let lastRequiredTab;
    const tabLists = res.map((item, i) => {
      // 第一个没有校验保存过的tab激活,其他未保存过的tab置灰,不可点击;
      if (!item.checked) {
        if (index === -1) {
          index = i;
          activeTab = item;
        } else {
          item.disabled = true;
        }
      }
      if (item.required && i > 0) {
        lastRequiredTab = item;
      }
      return item;
    });
    // 如果所有tab都校验保存过,则激活第一个tab
    if (!activeTab || (this.props.location.search && isMrnAble)) {
      // 判断从MRN打开，search为 '?fromMRN'
      const [active] = res;
      activeTab = active;
    }
    await this.getBtns(res, status, activeTab, lastRequiredTab);
    this.setState({
      tabLists,
      activeTab,
      activeEnum: window.checkTypeValue === 'entry' ? STEP_ENUM : BACKGROUND_STEP_ENUM,
    });
  };

  /**
   * 根据不同的状态生成底部的操作按钮
   * @param tabLists 标签列表
   * @param status 当前状态
   * @param data 包含 code 和 required 的数据对象
   * @param lastRequiredTab 最后一个必填标签的信息
   * @returns {Promise<void>}
   */
  getBtns = async (tabLists, status, data, lastRequiredTab = {} as any) => {
    const { code, required } = data;
    const { code: lastTabCode } = lastRequiredTab;
    const { editable } = this.state;
    let operateBtns = [];
    // 判断是否可以操作（状态为1或9）
    const canOperate = status === 1 || status === 9;

    if (!editable) {
      // 如果不可编辑，根据是否可操作设置按钮
      operateBtns = canOperate ? ['promise', 'edit', 'submit'] : [];
      this.setState({ operateBtns });
    } else if (!canOperate) {
      // 如果可编辑但不可操作，清空按钮
      this.setState({ operateBtns });
    } else {
      // 找到当前标签在列表中的索引
      const index = _.findIndex(tabLists, { code });
      // 检查所有必填标签是否已填写
      let tabListsValid = true;
      _.forEach(tabLists, (item) => {
        if (tabListsValid && !item.checked && item.required) {
          tabListsValid = false;
        }
      });

      if (index !== -1) {
        if (index !== 0 && index !== tabLists.length - 1) {
          // 处理中间标签的按钮
          if (status === 9 || code === lastTabCode) {
            operateBtns = required ? ['prev', 'next', 'preview', 'submit'] : ['prev', 'next', 'preview', 'submit'];
          } else if (tabListsValid) {
            operateBtns = required ? ['prev', 'next'] : ['prev', 'next', 'preview', 'promise', 'submit'];
          } else {
            operateBtns = ['prev', 'next'];
          }
        } else if (index === 0) {
          // 处理第一个标签的按钮
          if (status === 9 || code === lastTabCode) {
            operateBtns = ['next', 'preview', 'submit'];
          } else if (tabListsValid) {
            operateBtns = required ? ['next'] : ['next', 'preview', 'promise', 'submit'];
          } else {
            operateBtns = ['next'];
          }
        } else if (index === tabLists.length - 1) {
          // 处理最后一个标签的按钮
          if (tabListsValid) {
            operateBtns = ['prev', 'preview', 'promise', 'submit'];
          } else {
            operateBtns = required ? ['prev', 'preview', 'promise', 'submit'] : ['prev'];
          }
        }
        // 添加保存按钮
        operateBtns.push('save');
        // 更新状态
        this.setState({ operateBtns });
      }
    }
  };

  handleCheckChange = () => {
    const { check } = this.state;
    this.setState({ check: !check });
  };

  handleShowModal = () => {
    this.setState({ visible: true });
  };

  handleClose = () => {
    this.setState({ visible: false });
  };

  renderRightHeader = () => {
    const { status } = this.state;
    let right: ReactElement;
    if (status === 1 || status === 9) {
      let saveDate = '';
      if (saveDate) {
        saveDate = datejs(saveDate).format('YYYY/MM/DD HH:mm:ss').slice(11, 16);
      }
      right = (
        <div className="header-right">
          {saveDate && (
            <span className="saveDate">
              <span className="icon-clock" />
              保存于
              {saveDate}
            </span>
          )}
          <span className="logout" onClick={this.handleLogout}>
            退出
          </span>
        </div>
      );
    } else {
      right = (
        <span className="logout" onClick={this.handleLogout}>
          退出
        </span>
      );
    }
    return right;
  };

  // 渲染当前激活页签内容
  renderActiveTabContent = () => {
    const { activeTab, needComputerTypeValidate = false } = this.state;
    const { code } = activeTab;
    let content = null;
    switch (code) {
      case 'basicInfo':
        content = <BasicInfo location={this.props.location} ref={this.basicInfo} />;
        return content;
      case 'personalInfo':
        content =
          window.checkTypeValue === 'entry' ? (
            // 电脑类型在驳回后，需要自动校验
            <PersonInfo ref={this.personalInfo} needComputerTypeValidate={needComputerTypeValidate} />
          ) : (
            <PersonBackground ref={this.personalInfo} />
          );
        return content;
      case 'bankInfo':
        content = <BankInfo ref={this.bankInfo} />;
        return content;
      case 'educationsInfo':
        content = <EducationInfo ref={this.educationsInfo} />;
        return content;
      case 'worksInfo':
        content = <WorkInfo ref={this.worksInfo} />;
        return content;
      case 'declaration':
        content = <Declaration ref={this.declaration} />;
        return content;
      case 'commitment':
        content = <TaxInfo ref={this.commitment} />;
        return content;
      case 'healthInfo':
        content = <HealthInfo ref={this.healthInfo} />;
        return content;
      default:
        return null;
    }
  };

  renderPreview = () => {
    return <Preview hasShowAll={window.checkTypeValue === 'entry'} />;
  };

  render() {
    const { location } = this.props;
    const { operateBtns, tabLists, activeTab = {}, activeEnum, editable, saveDate, check, visible } = this.state;
    if (!activeTab.code) {
      return null;
    }
    const hasPromise = operateBtns.indexOf('promise') > -1; // 是否需要签署承诺书
    const btns = operateBtns;
    return (
      <div className={location.search && isMrnAble ? 'list show-in-mrn' : 'list'}>
        <div className="header">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
          {this.renderRightHeader()}
        </div>

        {/* 编辑态展示上方进度条（可点击） */}
        {editable && (
          <div className="menu">
            <Steps active={activeEnum[activeTab.code]} space="150px">
              {(tabLists || []).map((v) => (
                // @ts-expect-error Step 上没有 onClick 方法
                <Step title={v.name} key={v.id} onClick={(code) => this.handleClick(code, v)} />
              ))}
            </Steps>
          </div>
        )}

        {/* 内容区 */}
        <div className="content" key={activeTab.code}>
          <div className="content__wrapper">
            {/* 编辑态 */}
            {editable && this.renderActiveTabContent()}
            {/* 预览态 */}
            {!editable && this.renderPreview()}
          </div>
        </div>

        {/* 按钮区域 */}
        {btns && btns.length > 0 && (
          <div className="footer">
            {hasPromise && (
              <div className="footer__check">
                <Checkbox checked={check} onChange={this.handleCheckChange}>
                  我同意
                </Checkbox>
                <span className="footer__promise" onClick={this.handleShowModal}>
                  《个人信息使用确认书》
                </span>
              </div>
            )}
            {(btns || []).map((button) => {
              const btn = btnsMap[button];
              const { code, label } = btn;
              if (code === 'promise') return null; // 过滤允许签署按钮
              return (
                <Button
                  key={code}
                  // @ts-expect-error Button 的 type不支持 ''
                  type={code === 'submit' ? 'primary' : ''}
                  disabled={hasPromise && code === 'submit' && !check}
                  onClick={() => this.handleOperate(code)}
                >
                  {label}
                </Button>
              );
            })}
            {saveDate && (
              <div className="footer__save">
                <Icon type="time-o" />
                {saveDate}
              </div>
            )}
          </div>
        )}
        {/* 反馈组件（固定在屏幕右下角） */}
        <Feedback />
        {/* 个人信息承诺书 */}
        <ConformModal visible={visible} onClose={this.handleClose} />
      </div>
    );
  }
}
export default List;
